import { Typography, makeStyles, Box } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    backgroundColor: '#FFF4E5',
    borderRadius: '8px',
    padding: '14px 16px',
    alignItems: 'center',
  },
  icon: {
    color: '#EF6C00',
    marginRight: '12px',
  },
  title: {
    fontWeight: 'bold',
    color: '#663C00',
  },
  description: {
    color: '#2e6b31',
  },
}));

export const LeverageSubmarketAlert = ({submarket}) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <WarningIcon className={classes.icon} />
      <Box>
        <Typography className={classes.title} variant="body1">
            Warning: This is a {submarket == 1 ? '[L1]' : '[L2]'} submarket. Please see the <a href="/crm-portal/document-library-home" style={{ textDecoration: 'underline' }} target="_blank" rel="noopener noreferrer">product manual</a> for special guidelines
        </Typography>
      </Box>
    </Box>
  );
};
